export default [
    {
        path: '/emcadmin/plans/additional-services',
        name: 'emcadmin-plan-additional-services',
        component: () => import ('./views/AdditionalServiceIndex'),
        meta: {
            title: 'Serviços adicionais',
            icon: 'mdi-account-wrench-outline',
            breadcrumbs: [
                { text: 'Descrição da rota', disabled: true }
            ]
        }
    },
]
